import { InfoCircleFilled } from "@ant-design/icons"
import { CHECKBOX, INTERNAL } from "../../utils/Constants"
import UMCAttributeView from "./UMCAttributeView"
import { PURPLE } from "../../styles/styleUtils"
import { Tooltip } from "antd"
import UMCButton from "./UMCButton"
import { useState } from "react"
import MultideviceModal from "../UsersConfig/MultideviceModal"
import ProgrammableKeysModal from "../UsersConfig/ProgrammableKeys/ProgrammableKeysModal"
import { useDispatch, useSelector } from "react-redux"
import { handlePinCodeBtnChange, multideviceDECTCreation, multideviceDECTRegister, registerDECT, primaryDECTCreation } from "../../store/actions/UUMActions"
import SingleImage from "./SingleImage"
import { getTranslated } from "../../utils/CommonUtils"
import { findInObjectById, validateButtonAddon } from "../../utils/SchemaParseUtils"

/**
 * Component to display Label - Widget in two lines
 * @param {*} attribute 
 * @returns 
 */
const UMCAttrComponentView = ({ attribute }) => {

    const [selectedBtn, setSelectedBtn] = useState()
    const dict = useSelector(state => state.common.dict)
    const currentMergedData = useSelector((state) => state.common.currentMergedData)

    const dispatch = useDispatch()

    // To handle action on button addon click
    const handleAttrBtnClick = (btnId) => {
        setSelectedBtn(btnId)
        switch (btnId) {
            case "create": { // Easyuum: primary DECT Creation
                dispatch(primaryDECTCreation())
                break
            }
            case "register": { // Easyuum: primary DECT registration
                dispatch(registerDECT())
                break
            }
            case "pin-change": { // Easyuum: Pin code change btn
                dispatch(handlePinCodeBtnChange(attribute))
                break
            }
            case "dect-multidevice-create": { // Easyuum: secondary DECT Creation
                dispatch(multideviceDECTCreation())
                break
            }
            case "dect-multidevice-register": { // Easyuum: secondary DECT Registeration
                dispatch(multideviceDECTRegister())
                break
            }
            default:
                console.log("Modal popup under construction: ", selectedBtn)
                break
        }
    }

    const notifyModalClose = () => {
        setSelectedBtn("")
    }

    // To handle modal view on button addon click
    const getModalView = () => {
        switch (selectedBtn) {
            case "multidevice":
                return <MultideviceModal id="btn-modal" open={true} notifyClose={notifyModalClose} />
            case "programmablekeys":
                const directorynumberObj = findInObjectById(currentMergedData, "directorynumber")
                
                return <ProgrammableKeysModal id="btn-modal" open={true} notifyClose={notifyModalClose} dn={directorynumberObj?.value} />
            default:
                console.log("Modal popup under construction: ", selectedBtn)
                break
        }
    }

    return <>
        {((attribute.widget !== "NONE" && attribute.access !== INTERNAL) && (!attribute.link || (attribute.link && attribute.visible)))
            ? <div className={`${attribute.imageaddon ? "attr-label-wrap" : ""}`}>
                <div>
                    {(attribute.label && attribute.widget !== CHECKBOX) ? // Attribute Label
                        <div className={attribute.mandatory ? "detail-label mandatory-field" : "detail-label"}>
                            {getTranslated(dict, attribute.label)}:{(attribute.help) ?
                                <Tooltip title={getTranslated(dict, attribute.help)}>
                                    <InfoCircleFilled style={{ color: PURPLE, paddingLeft: "5px" }} />
                                </Tooltip> :
                                <></>}
                        </div> :
                        <></>}
                    <div className={`attr-widget ${attribute.isModalView ? "modal-attr" : ""}`} style={{ width: attribute.imageaddon ? "100%" : attribute.buttonaddon ? "80%" : "" }}>
                        <UMCAttributeView // Attribute widget
                            attribute={{ ...attribute, parentClassName: attribute.buttonaddon ? "attr-btn-view" : "attr-view" }}
                        />
                        {attribute.buttonaddon ? <UMCButton // Attribute button [optional]
                            {...attribute.buttonaddon}
                            type="primary"
                            className="button-addon-style"
                            onClick={() => handleAttrBtnClick(attribute.buttonaddon?.id)}
                            disabled={validateButtonAddon(attribute)}
                        /> :
                            <></>}
                    </div>
                </div>
                {attribute.imageaddon ? // Attribute image [optional]
                    <SingleImage
                        imageData={attribute.imageaddon}
                        className="attr-img-addon"
                        height="5em"
                        width="5em"
                    />
                    :
                    <></>}
            </div>
            :
            <></>}
        {selectedBtn && getModalView()}
    </>
}

export default UMCAttrComponentView